import { api } from "../../../software/api";
import { KINDS, dayLabel } from "./boardUtils";

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export async function printRunSheet(tech, date) {
  const w = window.open("", "_blank");
  const r = await api("GET", `/runsheet?tech=${encodeURIComponent(tech)}&date=${date}`);
  const row = (m, i) => `<tr><td class="n">${i + 1}</td><td><b>${esc(m.client_name || "")}</b><br>${esc(m.client_address)}<br>${esc(m.client_phone)}</td>
    <td><span class="k">${esc((KINDS[m.kind] || {}).label)}</span>${m.wo_number ? ` WO #${m.wo_number}` : ""}<br>${esc(m.text)}</td><td class="s"></td></tr>`;
  const html = `<html><head><title>Run Sheet ${esc(tech)} ${date}</title><style>
    body{font-family:Arial,sans-serif;font-size:12px;margin:18px;color:#111} h1{margin:0;font-size:20px} h2{margin:2px 0 10px;font-size:14px;color:#444}
    table{width:100%;border-collapse:collapse} td,th{border:1px solid #999;padding:6px;vertical-align:top;text-align:left}
    th{background:#eee} .n{width:22px;text-align:center;font-weight:bold} .s{width:120px} .k{font-weight:bold;text-transform:uppercase;font-size:10px}
    .note{border:1px dashed #999;padding:6px;margin:8px 0;font-weight:bold}</style></head><body>
    <h1>Glamour Pools and Spas — Technician Run Sheet</h1><h2>${esc(tech)} · ${esc(dayLabel(date))}</h2>
    ${r.shop_saturday ? `<div class="note">Rostered on SHOP / COUNTER this Saturday.</div>` : ""}
    ${r.away.map((a) => `<div class="note">AWAY / OUT: ${esc(a.text)}</div>`).join("")}
    <table><tr><th>#</th><th>Client / Address / Phone</th><th>Job</th><th>Notes / Sign-off</th></tr>
    ${r.jobs.map(row).join("") || `<tr><td colspan="4">No jobs booked.</td></tr>`}</table>
    ${r.overdue.length ? `<h2 style="margin-top:14px;color:#b91c1c">Overdue — still to do</h2><table>${r.overdue.map(row).join("")}</table>` : ""}
    <script>window.onload=()=>window.print()</script></body></html>`;
  w.document.write(html);
  w.document.close();
}
